import { adminHttpClient } from '../../commons/adminHttpClient'

export type getTaxSavingsTransactionDetails = {
  totalAccrued: number
  totalRequested: number
  totalApproved: number
  totalTaxAdvantaged: number
  totalTaxFree: number
  remainingExpenses: number
}[]

const getTaxSavingsTransactionDetails = (planPeriodId: string): Promise<getTaxSavingsTransactionDetails> => {
  return adminHttpClient.get(`Expenses/TaxSavings/GetTaxSavingsTransactionDetails/${planPeriodId}`)
}

export default getTaxSavingsTransactionDetails
